import { css } from '@emotion/react';
import { t } from 'i18n';

import { getLayoverTimesAndDuration } from '../../../utils';
import { theme } from '../../theme';

const styles = {
  durationText: css`
    color: ${theme.colors.gray[2]};
  `,
  transferTimeContainer: css`
    display: flex;
    gap: ${theme.spacing.xs};
    width: fit-content;

    margin-top: ${theme.spacing.md};
    margin-bottom: ${theme.spacing.md};
    font-size: ${theme.fontSize.xs};
  `,
};

type Props = {
  fromTime: string;
  toTime: string;
  airportCode: string;
  cityName: string;
  currentStop: number;
};

export const BoundLayover = ({ fromTime, toTime, airportCode, cityName, currentStop }: Props) => {
  const { hours, minutes, arrivalTime, departureTime } = getLayoverTimesAndDuration(fromTime, toTime);
  return (
    <div css={styles.transferTimeContainer}>
      <div>
        <span>{`${currentStop} ${currentStop > 1 ? t('common:stop') : t('common:stops')} ${cityName}`}</span>
        <b> {airportCode}</b>
      </div>
      <div style={{ display: 'flex', gap: '4px' }}>
        <div>{`${arrivalTime} - ${departureTime}`}</div>
        <div css={styles.durationText}>{`(${hours}h ${minutes}m)`}</div>
      </div>
    </div>
  );
};
